import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { UserX, ArrowLeft, UserPlus, LogIn } from 'lucide-react';
import '../../../assets/css/screens/customer/auth/googlemailnotfound.css';

const AccountNotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Google login se jo email aayi thi wo yahan show karne ke liye
  const email = location.state?.email || '';

  return (
    <div className="anf-page">
      <div className="anf-card">

        <button className="anf-back-btn" onClick={() => navigate('/')}>
          <ArrowLeft size={20} />
        </button>

        <div className="anf-icon-wrap">
          <UserX size={34} />
        </div>

        <h2 className="anf-title">Account Not Found</h2>

        <p className="anf-sub">
          {email ? (
            <>We couldn't find an account linked with <b>{email}</b>.</>
          ) : (
            <>We couldn't find an account linked with this Google email.</>
          )}
          <br />
          Please sign up first to continue.
        </p>

        <button
          className="anf-btn-primary"
          onClick={() => navigate('/', { state: { email } })}
        >
          <UserPlus size={17} /> Back to Home
        </button>

        {/* <button
          className="anf-btn-secondary"
          onClick={() => navigate('/login')}
        >
          <LogIn size={16} /> Back to Home
        </button> */}

      </div>
    </div>
  );
};

export default AccountNotFound;